import { render, staticRenderFns } from "./TheAlert.vue?vue&type=template&id=5118ddfc&scoped=true"
import script from "./TheAlert.vue?vue&type=script&lang=js"
export * from "./TheAlert.vue?vue&type=script&lang=js"
import style0 from "./TheAlert.vue?vue&type=style&index=0&id=5118ddfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5118ddfc",
  null
  
)

export default component.exports